import * as type from './types'
import actions from './actions'
import getters from './getters'


const state = {
  selectedShipment: null,
  isSelecting: false,
  isSettingProvider: false,
  errors: null,
  listPossibleProviders: null,
  isLoadingProviders: false,
  providersMenuFilters: null,
  isFetching: false,
  isSettingCustomProvider: false,
}

const initialState = {
  selectedShipment: null,
  isSelecting: false,
  isSettingProvider: false,
  errors: null,
  listPossibleProviders: null,
  isLoadingProviders: false,
  providersMenuFilters: null,
  isFetching: false,
  isSettingCustomProvider: false,
}

const mutations = {
  [type.SET_SELECTED_SHIPMENT](state, action) {
    if (state.selectedShipment != null) {
      if (state.selectedShipment.id === action.shipment.id) {
        state.selectedShipment = { ...state.selectedShipment, ...action.shipment }
      } else {
        state.selectedShipment = action.shipment
      }
    } else {
      state.selectedShipment = action.shipment
    }
  },
  [type.REMOVE_SELECTED_SHIPMENT](state) {
    state.selectedShipment = null
  },
  [type.SET_IS_SELECTING_SHIPMENT](state, action) {
    state.isSelecting = action.flag
  },
  [type.SET_SHIPMENTS_CONTEXT_ERRORS](state, action) {
    state.errors = action.error
  },
  [type.REMOVE_SHIPMENTS_CONTEXT_ERRORS](state) {
    state.errors = null
  },
  [type.SET_IS_LOADING_PROVIDERS] (state, action) {
    state.isLoadingProviders = action.flag
  },
  [type.SET_POSSIBLE_PROVIDERS] (state, action) {
    state.listPossibleProviders = action.providers
  },
  [type.SET_IS_SETTING_PROVIDER] (state, action) {
    state.isSettingProvider = action.flag
  },
  [type.UPDATE_SELECTED_SHIPMENT] (state, action) {
    if (action.shipment.schedule != null) {
      state.selectedShipment = { ...state.selectedShipment, ...action.shipment, schedule: {
        stops: state.selectedShipment.schedule.stops,
        metrics: action.shipment.schedule.metrics,
        connections: action.shipment.schedule.connections
      } }
    } else {
      state.selectedShipment = { ...state.selectedShipment, ...action.shipment }
    }
  },
  [type.SET_PROVIDERS_MENU_FILTER] (state, action) {
    state.providersMenuFilters = action.attribute
  },
  [type.REMOVE_PROVIDERS_MENU_FILTER] (state, action) {
    state.providersMenuFilters = null
  },
  [type.SET_SHIPMENTS_LABELS] (state, action) {
    state.selectedShipment = { ...state.selectedShipment, labels: action.labels }
  },
  [type.SET_RESET_STATE] (state, action) {
    Object.assign(state, initialState)
  },
  [type.SET_GOODS_VALUE_BY_DAY_FETCHING] (state, action) {
    state.isFetching = action.flag
  },
  [type.SET_GOODS_VALUE_ERROR] (state, action) {
    state.errors = action.error
  },
  [type.GOODS_VALUE_BY_DAY_UPDATED] (state, action) {
    state.selectedShipment = { ...state.selectedShipment, goodsValue: action.value }
  },
  [type.REMOVE_GOODS_VALUE_ERROR] (state) {
    state.errors = null
  },
  [type.SET_IS_SETTING_CUSTOM_PROVIDER] (state, action) {
    state.isSettingCustomProvider = action.flag
  }
}

export const shipmentsContext = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
